import React, { FC } from 'react';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt } from '../../views/login/Login';

export const ProfileHeader: FC = () => {
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);
	const userGroups = user?.['cognito:groups'];

	return (
		<div className="card mb-5">
			<div className="card-body">
				<div className="d-flex align-items-center">
					<div className="d-flex align-items-center justify-content-center text-danger fw-bolder bg-light-danger rounded-2 profile-icon p-13">
						<span>{user?.given_name?.[0] || ''}</span>
						<span>{user?.family_name?.[0] || ''}</span>
					</div>
					<div className="fs-2 fw-bolder ms-13">
						<span>{user?.given_name || ''}{' '}</span>
						<span>{user?.family_name || ''}</span>
						<div className="fs-7 text-muted">{userGroups.join(', ')}</div>
					</div>
				</div>
			</div>
		</div>
	);
};
